
import ApiError from "components/common/ApiError";
import Skeleton from "react-loading-skeleton";
import DynamicInput from "components/common/DynamicInput";

const { useUserOptions } = require("hooks/useUserOptions");

const UserSelect = ({ label, value, onChange, readOnly }) => {
    const { userOptions, isLoading, error, refetch } = useUserOptions();

    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message} />;
    if (isLoading) return <Skeleton height={40} count={1} />;
    return (
        <DynamicInput
            label={label} 
            value={value} 
            type="elementSelect"
            options={userOptions}
            onChange={onChange}
            readOnly={readOnly}/>
    )
}

export default UserSelect
